// apps/web/src/components/ui/SectionHeader.tsx
// The one section-label style: small uppercase muted, with an optional
// right-aligned action (e.g. an "Add" button).
import type { ReactNode } from "react";

export function SectionHeader({ children, action }: { children: ReactNode; action?: ReactNode }) {
  return (
    <div className="flex items-center justify-between gap-2">
      <h3 className="text-sm uppercase tracking-wider text-fg-muted font-semibold">{children}</h3>
      {action}
    </div>
  );
}
